export const SHOW_LOADER = 'SHOW_LOADER';
export const FETCH_EVENTS = 'FETCH_EVENTS';
export const MERGE_EVENTS = 'MERGE_EVENTS';